import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, IconX, LocaleX, ReqX, ZTime, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { ActivityIndicator, HStack, Spacer, VStack, XButton, XIconButton, XScroll, XText } from "IZOX/_X";
import Options from "shared/Options";
import QUICKUI from "shared/QUICKUI";
import { PageFlipper, QForm } from "IZOX/BLOCKS/Libs";
import ViewPolicy from "../../../PAAllPolicies/_gears/ViewPolicy";
import _ from "lodash";
import PolicyRow from "shared/PolicyRow";
import Styles from "__SYSDefault/Styles";
import VarList from "shared/VarList";

/**
 * @augments {Component<Props, State>}
 */
class ViewMaidW extends Component {

  static propTypes = {
    docID: PropsType.string
  }

  static defaultProps = {

  }

  constructor(props){
    super();
    this.state = {
      mode: "view",
      formValue: props?.maidDoc ?? {},
      page: 0,
      pageSize: 10
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetNationalityList();
      this.GetMaidAndPolicies();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ViewMaidW.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  GetNationalityList = async () => {
    let docs = await VarList.GetList("Nationality");
    this.setState({
      nationalities: docs
    });
  }

  GetMaidAndPolicies = async () => {
    let {docID} = this.props;
    if(!docID) return;
    let res = await ReqX.SendBE("/Web/Agent/GetMaidAndPolicies", {
      docID: docID
    });
    let {Success, payload} = res;
    if(Success){
      let {maidDoc, policyDocs, count} = payload;
      this.setState({
        maidDoc,
        policyDocs,
        count,
        formValue: maidDoc
      });
    }
  }

  _close = () => {
    let {Refresh} = this.props;
    Refresh?.();
    GFunc.CloseBackdrop();
  }

  _onFormChange = (formValue) => {
    this.setState({
      formValue: formValue
    });
  }

  _toView = () => {
    this.setState({
      mode: "view"
    });
  }

  _toEdit = () => {
    this.setState({
      mode: "edit"
    });
  }

  _toSuccess = () => {
    this.setState({
      mode: "success"
    });
  }

  _validateMaid = () => {
    let {formValue} = this.state;
    let valid = ZValidate.CheckAllFields(formValue, 
      [
        "fullName",
        "gender",
        "dateOfBirth",
        "nationality",
        "passport"
      ], "required"
    );
    if(!valid) return false;
    valid = ZValidate.CheckAllFields(formValue, ["dateOfBirth"], "isDate");
    if(!valid) return false;
    return true;
  }

  _onEditSubmit = async () => {
    let {formValue} = this.state;
    this.setState({
      loading: true
    }, async () => {
      let res = await ReqX.SendBE("/Web/Agent/EditMaid", {
        docID: formValue._id,
        formValue
      });
      let {Success} = res;
      if(Success){
        this.setState({
          loading: false
        }, () => {
          this._toSuccess();
        });
      }else{
        this.setState({
          loading: false
        });
        GFunc.Ask({
          EN: "Network problem.",
          TC: "網絡問題"
        },
        {
          EN: "Please try again later.",
          TC: "請稍後再試。"
        });
      }
    });
  }

  renderSuccess(){
    return (
      <VStack fullWidth spacing={16} pT={30}>
        <VStack fullWidth fitHeightToContent spacing={30}>
          <HStack pH={16}>
            <XText fontSize={28} color={ColorX.CSS("Leaf")} bold>
              {LocaleX.Parse({
                EN: "Maid Updated Successfully",
                TC: "已成功更新工人"
              })}
            </XText>
          </HStack>
          <HStack pH={16}>
            <XText fontSize={14} color={ColorX.CSS("Stone")} bold>
              {LocaleX.Parse({
                EN: "It will be shown on the Maid Management page",
                TC: "將會顯示在客戶管理頁面"
              })}
            </XText>
          </HStack>
          <HStack>
            <XButton {...Styles.QFBtn} width={200} onPress={this._close}
              padding={0} pV={8}>
              <HStack>
                <XText bold>
                  {LocaleX.Parse({
                    EN: "Back to dashboard",
                    TC: "返回"
                  })}
                </XText>
              </HStack>
            </XButton>
          </HStack>
        </VStack>
        <HStack spacing={16} 
          style={{
            borderTopWidth: 1, 
            borderTopStyle: "solid",
            borderTopColor: ColorX.CSS("greyOut", 0.3)
          }} 
          HAlign="]" pH={16}>
          <XButton fitWidthToContent onPress={this._close}
            color={ColorX.CSS("Axit")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Close",
                  TC: "關閉"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>        
      </VStack>
    );
  }

  _onPageSizeChange = (pageSize) => {
    this.setState({
      pageSize: pageSize
    });
  }

  _onPageChange = (page) => {
    this.setState({
      page: page
    });
  }

  _toPopupDetails = async (_id) => {
    GFunc.Backdrop(() => {
      return (
        <ViewPolicy docID={_id}/>
      );
    }, {}, false);
  }

  renderTitleBar(){
    return (
      <HStack pH={16} shadow>
        <XText fontSize={16} bold>
          {LocaleX.Parse({
            EN: "Helper Details",
            TC: "助理詳細資料"
          })}
        </XText>
        <Spacer/>
        <XIconButton onPress={this._close}>
          {IconX.Get("ant", "close", 20, ColorX.CSS("Stone"))}
        </XIconButton>
      </HStack>
    );
  }

  renderTextPreview(label, value, width = 320){
    return (
      <VStack width={width}>
        <HStack HAlign="[" spacing={4}>
          <XText fontSize={14} color={ColorX.CSS("Gray4")}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <HStack HAlign="[" spacing={4}>
          <XText fontSize={14} color={ColorX.CSS("Stone")}>
            {LocaleX.Parse(value)}
          </XText>
        </HStack>
      </VStack>
    );
  }

  renderGI(){
    let {nationalities, maidDoc} = this.state;
    let {fullName, nationality, dateOfBirth, passport, gender, workingAddress} = maidDoc ?? {};
    let _gender = Options.GetOption("Gender", gender);
    let _nationality = VarList.GetOption(nationalities, nationality);
    return (
      <VStack fullWidth pB={4} pH={16}>
        <VStack bW={2} bColor={ColorX.CSS("Leaf")} fullWidth>
          <HStack bgColor={ColorX.CSS("Leaf")} HAlign="[" pH={16} pV={8}>
            <XText color={ColorX.CSS("pureWhite")} bold>
              {LocaleX.Parse({
                EN: "General Information",
                TC: "基本資料",
              })}
            </XText>  
          </HStack>
          <HStack p={8} HAlign="[">
            {this.renderTextPreview(
              {EN: "Name", TC: "姓名"},
              fullName ?? "NULL")}
          </HStack>
          <HStack spacing={16} p={8}>
            {this.renderTextPreview(
              {
                EN: "Date of birth",
                TC: "出生日期"
              },
              dateOfBirth ? ZTime.Moment(dateOfBirth).format("DD/MM/YYYY") 
                : "NULL")}
            {this.renderTextPreview(
              {
                EN: "Gender",
                TC: "性別"
              },
              LocaleX.Parse(_gender?.cap ?? "NULL"))}
          </HStack>
          <HStack p={8} spacing={16}>
            {this.renderTextPreview(
              {EN: "Passport number / HKID", TC: "護照 / 香港身份證號碼"},
              passport ?? "NULL")}
            {this.renderTextPreview(
              {
                EN: "Nationality",
                TC: "國籍"
              },
              LocaleX.Parse(_nationality?.name ?? "NULL"))}
          </HStack>
          <HStack p={8} spacing={16} HAlign="[">
            {this.renderTextPreview(
              {
                EN: "Working Address",
                TC: "工作地點"
              },
              LocaleX.Parse(workingAddress ?? "NULL"))}
          </HStack>
        </VStack>
      </VStack>
    );
  }

  renderPolicyDoc(doc, idx){
    let {_id} = doc;
    return (
      <PolicyRow key={idx} policyDoc={doc} 
        onViewDetailPress={() => this._toPopupDetails(_id)}/>
    );
  }

  renderPolicy(){
    let {policyDocs, page, pageSize, count, search} = this.state;
    let _docs = _.slice(policyDocs, page * pageSize, (page + 1) * pageSize);
    if(_docs.length === 0){
      return QUICKUI.NoDocs({
        EN: "There is no policies.",
        TC: "沒有任何保單。"
      });
    }
    let totalDocs = 0;
    if(search){
      totalDocs = policyDocs.length;
    }else{
      totalDocs = count ?? 0;
    }
    
    return (
      <VStack fullWidth pH={16}>
        <XScroll maxHeight={300}>
          {_.map(_docs, (o, i) => {
            return this.renderPolicyDoc(o, i);
          })}
        </XScroll>
        <PageFlipper totalDocs={totalDocs} 
          page={page}
          pageSize={pageSize}
          onPageSizeChange={this._onPageSizeChange}
          onPageChange={this._onPageChange}
          popupPosition="top" 
          mainColor={ColorX.CSS("Axit")} />
      </VStack>
    );
  }

  renderView(){
    return (
      <VStack fullWidth>
        {this.renderGI()}
        {this.renderPolicy()}
        {QUICKUI.PopupFooterButton(this._close, this._toEdit, 
          {
            nextCap: {
              EN: "Update",
              TC: "更新"
            }
          })}
      </VStack>
    );
  }

  renderEdit(){
    let {formValue, nationalities, loading} = this.state;
    return (
      <VStack>
        <QForm fullWidth pH={16} mB={16}
          onChange={this._onFormChange} value={formValue}>
          <VStack fullWidth pB={4}>
            <HStack HAlign="[" p={8}>
              <XText color={ColorX.CSS("Leaf")}>
                {LocaleX.Parse({
                  EN: "Please note that the price and regulations for male helpers will be different.",
                  TC: "請注意，男傭的價格和規定會有所不同。"
                })}
              </XText> 
            </HStack>
            <HStack p={8}>
              {QUICKUI.WebTextField("fullName",
                {EN: "Name", TC: "姓名"},
                {width: "100%", 
                  errorMessage: 
                    ZValidate.GetErrorMsg(Accessor.Get(formValue, "fullName"),
                      ["required"])
                })}
            </HStack>
            <HStack spacing={16} p={8}>
              {QUICKUI.WebDateField("dateOfBirth", {
                EN: "Date of birth",
                TC: "出生日期"
              }, {
                minDate: ZTime.Now().add(-60, "years").toISOString(),
                maxDate: ZTime.Now().add(-18, "years").toISOString(),
                defaultDisYear: ZTime.Now().add(-25, "years").year(), 
                errorMessage: ZValidate.GetErrorMsg(Accessor.Get(formValue, "dateOfBirth"),
                ["required"])
              })}
              {QUICKUI.WebDropdown("gender", {
                EN: "Gender",
                TC: "性別"
              }, Options.GetOptionList("Gender"), {
                width: 329,
                placeholder: {
                  EN: "Gender",
                  TC: "性別"
                },
                errorMessage: ZValidate.GetErrorMsg(Accessor.Get(formValue, "gender"),
                ["required"])
              })}
            </HStack>
            <HStack p={8} spacing={16}>
              {QUICKUI.WebTextField("passport",
                {EN: "Passport number / HKID", TC: "護照 / 香港身份證號碼"},
                {
                  errorMessage: ZValidate.GetErrorMsg(Accessor.Get(formValue, "passport"),
                    ["required"])
                })}
              <VStack width={329}>
                {QUICKUI.WebDropdown("nationality", {
                  EN: "Nationality",
                  TC: "國籍"
                }, nationalities, {
                  placeholder: {
                    EN: "Nationality",
                    TC: "國籍"
                  },
                  valAccessor: "_id",
                  capAccessor: "name", 
                  errorMessage: ZValidate.GetErrorMsg(Accessor.Get(formValue, "nationality"),
                    ["required"])
                })}
              </VStack>
            </HStack>
          </VStack>
        </QForm>
        {QUICKUI.PopupFooterButton(this._close, this._onEditSubmit, 
          {
            nextCap: {
              EN: "Submit",
              TC: "提交"
            },
            validateNext: this._validateMaid
          }, loading)}
      </VStack>
    );
  }

  renderMain(){
    let {mode} = this.state;
    switch(mode){
      default: case "view": return this.renderView();
      case "edit": return this.renderEdit();
      case "success": return this.renderSuccess();
    }
  }

  render(){
    let {maidDoc} = this.state;
    if(!maidDoc) return <ActivityIndicator loading/>;
    return (
      <VStack bgColor={ColorX.CSS("NotQuiteWhite")}
        width={705} maxHeight={window.innerHeight * 0.9}>
        {this.renderTitleBar()}
        {this.renderMain()}
      </VStack>
    );
  }

}

export default observer(ViewMaidW);
